import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {museumList} from '../../../services/InvitationServices';

export default function MuseumColumnDisplay() {
  const [museums, setMuseums] = useState([]);

  useEffect(() => {
    getMuseum();
  }, []);

  const getMuseum = () => {
    museumList('get').then(res => {
      setMuseums(res?.data);
    })
  }

  return (
    <Box sx={{mt: 3}}>
      {museums?.map((museum, index) => (
        <Box key={index} sx={{mb: 2}}>
          <Typography className={'text-bold'}>
            {museum?.name}
          </Typography>
          <Typography>
            {museum?.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}